import { lazy } from "react";
import WithSuspense from "../components/Loaders/WithSuspense";
import { PATHS } from "./constants";
import { Navigate } from "react-router-dom";

const {
  HOME,
  REGPAGE,
  REWARDS,
  TERMS,
  BTERMS,
  DSA_AGREEMENT,
  DSA,
  POLICY,
  APISERVICES,
  INVOICE,
  PAYMENT_LINK,
  B_COMMERCE,
} = PATHS;

const Home = WithSuspense(lazy(() => import("../pages/Home/Home")));
const BusinessRegistration = WithSuspense(
  lazy(() => import("../pages/BusinessRegistration/BusinessRegistration"))
);
const Policy = WithSuspense(lazy(() => import("../pages/Policies/Policies")));
const Terms = WithSuspense(lazy(() => import("../pages/Terms/Terms")));
const BTerms = WithSuspense(
  lazy(() => import("../pages/BusinessRegistrationTerms/BTerms.js"))
);
const DsaAgreement = WithSuspense(
  lazy(() => import("../pages/DsaAgreement/DsaAgreement"))
);
const ApiServicesPlaceholder = WithSuspense(
  lazy(() => import("../pages/ApiServices/ApiServicesPlaceholder"))
);
const Rewards = WithSuspense(lazy(() => import("../pages/Rewards/Rewards")));
const Invoice = WithSuspense(lazy(() => import("../pages/Invoice/Invoice")));
const PaymentLink = WithSuspense(
  lazy(() => import("../pages/PaymentLink/PaymentLink"))
);
const BCommerce = WithSuspense(
  lazy(() => import("../pages/BCommerce/BCommerce"))
);
const Dsa = WithSuspense(lazy(() => import("../pages/Dsa/Dsa")));

export const ROUTES = [
  { path: HOME, element: <Home /> },
  { path: REGPAGE, element: <BusinessRegistration /> },
  { path: REWARDS, element: <Rewards /> },
  { path: INVOICE, element: <Invoice /> },
  { path: PAYMENT_LINK, element: <PaymentLink /> },
  { path: B_COMMERCE, element: <BCommerce /> },
  { path: DSA, element: <Dsa /> },
  { path: "*", element: <Navigate to="/" replace /> },
  { path: POLICY, element: <Policy /> },
  { path: TERMS, element: <Terms /> },
  { path: BTERMS, element: <BTerms /> },
  { path: DSA_AGREEMENT, element: <DsaAgreement /> },
  { path: APISERVICES, element: <ApiServicesPlaceholder /> },
];
